import i18n from '@/i18n';
import Info from './Info';
import Cars from './Cars';
import Driver from './Driver';
import Card from './Card';
import AssociationSet from './AssociationSet'; //$IMPORT$

export default () => [
  {
    resourceName: i18n.t('company-index-1992f2b74ec999469-1'),
    routerUrl: '/company',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      Info(),
      Cars(),
      Driver(),
      Card(),
      AssociationSet(), //$MORE$
    ],
  },
];
